import { useQuery } from '@tanstack/react-query';
import { getStreaks, getTodayLeaderboard } from '../api';

export default function StreaksAndToday() {
  const { data: streaks } = useQuery({ queryKey: ['streaks'], queryFn: getStreaks, refetchInterval: 5 * 60_000 });
  const { data: today } = useQuery({ queryKey: ['today-leaders'], queryFn: getTodayLeaderboard, refetchInterval: 60_000 });

  const topStreaks = (streaks?.streaks ?? []).slice(0, 6);
  const todayEntries = (today?.entries ?? []).filter((e) => e.total !== 0 || e.matches > 0).slice(0, 6);

  if (topStreaks.length === 0 && todayEntries.length === 0) return null;

  return (
    <section className="grid grid-cols-1 sm:grid-cols-2 gap-3">
      {todayEntries.length > 0 && (
        <div className="card p-4">
          <div className="flex items-baseline justify-between mb-2">
            <h2 className="text-xs uppercase tracking-widest text-dim">Matchday leaderboard</h2>
            <span className="text-[10px] text-dim">{today?.matches ?? 0} match{today?.matches === 1 ? '' : 'es'} today</span>
          </div>
          <ol className="space-y-1">
            {todayEntries.map((e, i) => (
              <li key={e.user} className="flex items-center gap-2 text-sm">
                <span className="w-4 text-right font-mono text-dim text-[10px]">{i + 1}</span>
                <span className="flex-1 truncate">{e.user}</span>
                <span className="text-[10px] text-dim">
                  {e.prediction_points > 0 && `${e.prediction_points}p`}
                  {e.prediction_points > 0 && e.bet_winnings !== 0 && ' · '}
                  {e.bet_winnings !== 0 && `${e.bet_winnings > 0 ? '+' : ''}${e.bet_winnings}€`}
                </span>
                <span className="stat w-12 text-right text-pitch-400">{e.total}</span>
              </li>
            ))}
          </ol>
          <p className="text-[10px] text-dim mt-2">Prediction points + net bet PnL for matches kicking off today (Riga).</p>
        </div>
      )}
      {topStreaks.length > 0 && (
        <div className="card p-4">
          <div className="flex items-baseline justify-between mb-2">
            <h2 className="text-xs uppercase tracking-widest text-dim">Prediction streaks</h2>
            <span className="text-[10px] text-dim">current · best</span>
          </div>
          <ol className="space-y-1">
            {topStreaks.map((s, i) => (
              <li key={s.user} className="flex items-center gap-2 text-sm">
                <span className="w-4 text-right font-mono text-dim text-[10px]">{i + 1}</span>
                <span className="flex-1 truncate">{s.user}</span>
                <span className="stat text-cyan-400 w-8 text-right" title="Current">{s.current}</span>
                <span className="text-dim text-xs">·</span>
                <span className="stat text-pitch-400 w-8 text-right" title="Best">{s.best}</span>
              </li>
            ))}
          </ol>
          <p className="text-[10px] text-dim mt-2">Consecutive predictions with the correct outcome (≥3 pts).</p>
        </div>
      )}
    </section>
  );
}
